import apple from "@/assets/information/every-dollar-makes-a-difference/apple.svg";
import basketball from "@/assets/information/every-dollar-makes-a-difference/basketball.svg";
import celebration from "@/assets/information/every-dollar-makes-a-difference/celebration.svg";
import fiveHours from "@/assets/information/every-dollar-makes-a-difference/five-hours.svg";
import hospital from "@/assets/information/every-dollar-makes-a-difference/hospital.svg";
import icu from "@/assets/information/every-dollar-makes-a-difference/icu.svg";
import oxygen from "@/assets/information/every-dollar-makes-a-difference/oxygen.svg";
import paintBrush from "@/assets/information/every-dollar-makes-a-difference/paintbrush.svg";
import stethoscope from "@/assets/information/every-dollar-makes-a-difference/stethoscope.svg";
import wagon from "@/assets/information/every-dollar-makes-a-difference/wagon-no-tag.svg";
import xray from "@/assets/information/every-dollar-makes-a-difference/x-ray.svg";
import DifferenceItem from "./make-a-difference-item.jsx";

export default function EveryDollarCountsPage() {
  const items = [
    {
      amount: 10,
      icon: basketball,
      boldText: "NEW TOY",
      message: "Could help provide a NEW TOY for hospital play areas",
      outerWrapperClass: "col-span-1",
    },
    {
      amount: 25,
      icon: celebration,
      boldText: "4 NO MORE CHEMO PARTIES",
      message: "Could help cover the cost of 4 NO MORE CHEMO PARTIES",
      outerWrapperClass: "col-span-1",
    },
    {
      amount: 50,
      icon: paintBrush,
      boldText: "ART SUPPLIES",
      message: "Could help provide ART SUPPLIES for patient art parties",
      outerWrapperClass: "col-span-1",
    },
    {
      amount: 100,
      icon: wagon,
      boldText: "1 WAGON",
      message: "Could help cover the cost of 1 WAGON",
      isLarge: true,
      position: "left",
      outerWrapperClass: "col-span-full",
    },
    {
      amount: 150,
      icon: apple,
      boldText: "1 WEEK",
      message: "Could help provide meals for a St. Jude family for 1 WEEK",
      outerWrapperClass: "col-span-1",
    },
    {
      amount: 350,
      icon: xray,
      boldText: "9 CHEST X-RAYS",
      message: "Could help provide 9 CHEST X-RAYS, one view",
    },
    {
      amount: 800,
      icon: fiveHours,
      boldText: "5 HOURS OF PHYSICAL THERAPY",
      message: "Could help provide a St. Jude patient 5 HOURS OF PHYSICAL THERAPY",
      outerWrapperClass: "2xl:col-start-3",
    },
    {
      amount: 1500,
      icon: hospital,
      boldText: "1 DAY OF CHEMOTHERAPY",
      message: "Could help cover the cost for 1 DAY OF CHEMOTHERAPY",
      position: "left",
      outerWrapperClass: "col-span-full",
    },
    {
      amount: 2500,
      icon: stethoscope,
      boldText: "2 DAYS OF OUTPATIENT VISITS",
      message: "Help provide 2 DAYS OF OUTPATIENT VISITS",
      outerWrapperClass: "col-span-1",
    },
    {
      amount: 5000,
      icon: oxygen,
      boldText: "17 DAYS OF OXYGEN",
      message: "Could help cover the cost of 17 DAYS OF OXYGEN for a St. Jude patient",
      outerWrapperClass: "col-span-1 xl:col-start-3",
    },
    {
      amount: 7500,
      icon: icu,
      boldText: "2 DAYS IN THE ICU",
      message: "Could help cover the daily room rate for 2 DAYS IN THE ICU",
      outerWrapperClass: "col-span-full",
    },
  ];

  return (
    <div className="select-none">
      <div className="grid grid-cols-1 2xl:grid-cols-3 gap-1 my-4 mx-0">
        {items.map((item) => (
          <div
            key={item.amount}
            className={`${item.outerWrapperClass} difference-item-wrapper relative mb-4`}
          >
            <DifferenceItem
              icon={item.icon}
              message={item.message}
              boldText={item.boldText}
              amount={item.amount}
              isLarge={item.isLarge}
              position={item.position}
              textClass={item.textClass}
              iconClass={item.iconClass ? item.iconClass : "p-2"}
              wrapperClass={
                item.wrapperClass
                  ? `w-full flex items-center justify-center my-8 ${item.wrapperClass}`
                  : "w-full flex items-center justify-center my-8"
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
}
